import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	FlatRowSelect,
	type FlatRowSelectOption,
} from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type Props<
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TValue extends string | number,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	label: string;
	options: FlatRowSelectOption<TValue>[];
	drawerTitle?: string;
	isLast?: boolean;
	onValueChange?: (value: TValue) => void;
};

export const FlatRowFormSelect = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TValue extends string | number = string,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	label,
	options,
	drawerTitle,
	isLast,
	onValueChange,
}: Props<FormType, TName, TValue, TContext, TTransformed>) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({
				field: { value, onChange, onBlur },
				fieldState: { error },
			}) => (
				<FlatRowSelect<TValue>
					label={label}
					value={(value ?? "") as TValue | ""}
					options={options}
					onChange={(next) => {
						onChange(next);
						onValueChange?.(next);
					}}
					onBlur={onBlur}
					drawerTitle={drawerTitle}
					isLast={isLast}
					error={!!error?.message}
					helperText={error?.message}
				/>
			)}
		/>
	);
};
